<script setup lang="ts">
  import { SelectInput, IconImage } from '@/shared/ui';
  import AddButton from '@/shared/assets/icons/AddButton.svg';
  import DeleteButton from '@/shared/assets/icons/DeleteButton.svg';
  import type { FunctionalActivityRow, Option } from '@/pages/admin/lib/useEditMemberForm';

  defineProps<{
    hasFunctionalActivity: boolean;
    radioGroupName: string;
    functionalActivities: FunctionalActivityRow[];
    isLoadingActivities: boolean;
    canAddFunctionalActivity: boolean;
    getFilteredFaOptions: (index: number) => Option[];
  }>();

  const emit = defineEmits<{
    toggle: [value: boolean];
    updateActivity: [index: number, functionalActivityId: string | number];
    addActivity: [];
    removeActivity: [index: number];
  }>();
</script>

<template>
  <div>
    <p class="text-sm text-gray-07 font-semibold mb-2">
      Atividade Funcional:
    </p>

    <div class="flex items-center gap-6 mb-3">
      <label class="flex items-center gap-2 text-sm text-gray-07 cursor-pointer">
        <input
          type="radio"
          :name="radioGroupName"
          :checked="!hasFunctionalActivity"
          data-testid="fa-radio-no"
          class="accent-[var(--theme-secondary)]"
          @change="emit('toggle', false)"
        >
        Não
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-07 cursor-pointer">
        <input
          type="radio"
          :name="radioGroupName"
          :checked="hasFunctionalActivity"
          data-testid="fa-radio-yes"
          class="accent-[var(--theme-secondary)]"
          @change="emit('toggle', true)"
        >
        Sim
      </label>
    </div>

    <div
      v-if="hasFunctionalActivity"
      class="flex flex-col space-y-4"
    >
      <div
        v-for="(activity, index) in functionalActivities"
        :key="activity._key"
        class="flex gap-4 items-end"
      >
        <div class="flex-1 flex flex-col gap-2">
          <SelectInput
            :model-value="activity.functionalActivityId"
            :options="getFilteredFaOptions(index)"
            :disabled="isLoadingActivities"
            :label="isLoadingActivities ? 'Carregando...' : 'Selecione uma Atividade'"
            container-class="w-full"
            :use-teleport="true"
            @update:model-value="emit('updateActivity', index, $event)"
          />
        </div>
        <div class="flex items-center h-[42px]">
          <IconImage
            v-if="index === 0"
            :src="AddButton"
            alt="Adicionar atividade funcional"
            :class="['text-[var(--theme-secondary-ink)]', canAddFunctionalActivity ? 'cursor-pointer hover:opacity-80' : 'opacity-30 cursor-not-allowed']"
            @click="canAddFunctionalActivity && emit('addActivity')"
          />
          <IconImage
            v-else
            :src="DeleteButton"
            alt="Remover atividade funcional"
            class="cursor-pointer text-gray-05 hover:text-gray-07"
            @click="emit('removeActivity', index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
